import { FileList3 } from "@styled-icons/remix-line/FileList3";
import { Map2 } from "@styled-icons/remix-line/Map2";
import { Flex, Grid, theme } from "antd";
import React, { useContext } from "react";
import { createRoot } from "react-dom/client";

import { MAP_ID } from "./constants";
import { LocationFinderContext, LocationFinderProvider } from "./context";
import { LocationList } from "./LocationList";
import { StickyButton } from "./StickyButton";
import { MapContainer, MapRoot, MobileDrawer } from "./styled";

import { AppletWrapper } from "~/Atom/AppletWrapper";
import { isAppletPicker, isDevelopment } from "~/env";
import { useFlag } from "~/LaunchDarkly";

const Applet: React.FC = () => {
  const hasAuthorization = useFlag("applet-es-location-finder");

  const { token } = theme.useToken();
  const breakpoints = Grid.useBreakpoint();

  const ctx = useContext(LocationFinderContext);

  if (hasAuthorization !== true) {
    return null;
  }

  return (
    <Flex
      gap="small"
      justify="flex-start"
      align="flex-start"
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        margin: "0",
      }}
    >
      {breakpoints.lg ? (
        <LocationList />
      ) : (
        <MobileDrawer
          $token={token}
          $breakpoints={breakpoints}
          placement="left"
          closable={false}
          open={ctx.isDrawerOpen}
          getContainer={false}
          style={{
            width: "100vw",
            zIndex: "10 !important",
            padding: !breakpoints.md ? "0.5rem !important" : undefined,
          }}
        >
          <AppletWrapper appletName="location-finder" isComponentWrapper={true}>
            <Flex justify="center" align="flex-start">
              <LocationList />
              {!breakpoints.lg && (
                <StickyButton
                  icon={
                    <Map2
                      fill={token.colorWhite}
                      style={{ height: "1.5rem", width: "1.5rem" }}
                    />
                  }
                  onClick={() => ctx.setIsDrawerOpen(false)}
                  zIndex={100}
                >
                  {"Map"}
                </StickyButton>
              )}
            </Flex>
          </AppletWrapper>
        </MobileDrawer>
      )}

      <MapContainer>
        <MapRoot id={MAP_ID} />
        {breakpoints.lg ? null : (
          <StickyButton
            icon={
              <FileList3
                fill={token.colorWhite}
                style={{ height: "1.5rem", width: "1.5rem" }}
              />
            }
            onClick={() => ctx.setIsDrawerOpen(true)}
            zIndex={99}
          >
            {"List"}
          </StickyButton>
        )}
      </MapContainer>
    </Flex>
  );
};

export const mount = (el: HTMLDivElement) => {
  const root = createRoot(el);

  const bodyStyle = getComputedStyle(document.querySelector("body")!);

  root.render(
    <AppletWrapper
      appletName="location-finder"
      style={
        isAppletPicker || isDevelopment
          ? {
              height: `calc(100vh - ${bodyStyle.marginTop} - ${bodyStyle.marginBottom})`,
              width: `calc(100vw - ${bodyStyle.marginLeft} - ${bodyStyle.marginRight})`,
            }
          : {
              height: "100%",
              width: "100%",
            }
      }
      devFixedWidth={true}
    >
      <LocationFinderProvider>
        <Applet />
      </LocationFinderProvider>
    </AppletWrapper>
  );
};
